export const useSlideoverToggle = () => {
  const slideoverState = useState('slideoverState', () => false);
  const setSlideoverState = (newState: boolean) => {
    slideoverState.value = newState;
  };
  return {
    slideoverState,
    setSlideoverState,
  };
};
